import { assignmentApi } from "@/api/assignment/assignmentApi";
import type { AppDispatch } from "@/store";

/**
 * Чат задания, которое студент уже завершил: сдал или вышел срок.
 *
 * Контракт: true — сообщения этого чата студенту больше не показываем.
 * В событии ChatMessagePosted бэкенд присылает только chat_id, поэтому задание
 * ищем в списке заданий студента, а is_finished там считает сам бэкенд — тот же
 * признак, что в кабинете. Не нашли задание или запрос упал — false: лишнее
 * сообщение лучше потерянного.
 */

/* Свежие задания идут первыми, поэтому хватает одной страницы. Запрос мимо кэша:
   менеджер мог только что возобновить попытку. */
const FIELDS = ["id", "chat_id", "is_finished"];
const LIMIT = 50;

/* Чат экзамена, открытый у студента (StudentChatPanel на экране попытки): задание
   по нему идёт, сервер не спрашиваем. Сообщение без адресата бэкенд шлёт всем
   участникам чата — иначе каждый студент на экзамене ответил бы на него запросом. */
let examChatOnScreen: number | null = null;

export function setExamChatOnScreen(chatId: number | null) {
  examChatOnScreen = chatId;
}

export async function isFinishedAssignmentChat(dispatch: AppDispatch, chatId: number) {
  if (chatId === examChatOnScreen) return false;

  try {
    const response = await dispatch(
      assignmentApi.endpoints.getAssignmentsAsManager.initiate(
        { limit: LIMIT, orderBy: "desc", fields: FIELDS },
        { forceRefetch: true, subscribe: false }
      )
    ).unwrap();

    return response.entities.data.some(
      (assignment) => assignment.chat_id === chatId && assignment.is_finished === true
    );
  } catch {
    return false;
  }
}
